import React from 'react';
import { FiArrowUpRight } from 'react-icons/fi';

const TILES = [
  {
    href: '#newsletter',
    variant: 'pink',
    kicker: 'Stay in touch',
    title: 'Join the list',
    desc: 'Updates on new books, videos, merch, and friends.',
  },
  {
    href: '#amazon',
    variant: 'gold',
    kicker: 'Available now',
    title: 'Buy now',
    desc: 'Coloring book & story adventures — order today.',
  },
  {
    href: '#discover',
    variant: 'purple',
    kicker: 'Discover more',
    title: 'Stories & more',
    desc: 'Stories, cozy gear, and read-alongs.',
  },
  {
    href: '#social',
    variant: 'teal',
    kicker: 'Follow along',
    title: 'Social',
    desc: 'Facebook, Instagram, YouTube, and TikTok.',
  },
];

export default function CtaTiles() {
  return (
    <div className="cta-tiles">
      {TILES.map(tile => (
        <a key={tile.href} href={tile.href} className={`cta-tile cta-tile--${tile.variant}`}>
          <span className="cta-tile__kicker">{tile.kicker}</span>
          <span className="cta-tile__title">{tile.title}</span>
          <span className="cta-tile__desc">{tile.desc}</span>
          <span className="cta-tile__icon" aria-hidden>
            <FiArrowUpRight size={22} />
          </span>
        </a>
      ))}
    </div>
  );
}
